/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    BackboneRadio = require('backbone.radio'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    phoneify = require('../utilities/phoneify'),
    user = require('../models/user');

module.exports = Backbone.Model.extend({
    channels: {
        program: BackboneRadio.channel('program')
    },
    favorite: function (value) {
        // eslint-disable-next-line no-undefined
        if (value !== undefined) {
            if (this.get('isFavorite') !== value ? 1 : 0) {
                // console.log('@acavan - program.favorite - value:%s attribute:%s', value, this.get('isFavorite'));
                this.set({isFavorite: value ? 1 : 0}, {silent: false});
                jQuery.ajax({
                    contentType: 'application/json',
                    dataType: 'json',
                    headers: user.authorizationHeader('program'),
                    method: value ? 'POST' : 'DELETE',
                    url: configuration.apiUrlBase + 'favorite/' + this.id
                }).done(_.bind(function (/*data, statusText, xhr*/) {
                    // console.log('@acavan - program.favorite.done - value:%s attribute:%s', value, this.get('isFavorite'));
                    if (this.collection) {
                        this.collection.trigger('change:favorite');
                    }
                }, this)).fail(function (xhr, errorText, error) {
                    console.error('program.favorite.fail - error:%s (%s)', errorText, error.toString());
                });
            }
        }
        return this.get('isFavorite');
    },
    initialize: function () {
        this.listenTo(user, 'change:roles', function () {
            this.roleChanged = true;
        });
    },
    parse: function (results) {
        const result = _.isArray(results) ? results[0] : results;
        result.phone = phoneify(result.phone);
        if (result.website) {
            if (result.website.indexOf('http') !== 0) {
                result.website = 'https://' + result.website;
            }
            result.websiteDisplay = result.website.substr(result.website.indexOf('https://') === 0 ? 8 : 7);
        }
        this.roleChanged = false;
        return result;
    },
    sync: function (method, model, options) {
        const url = configuration.apiUrlBase + 'program/',
            id = options.id || this.id,
            ajax = function (ajaxOptions) {
                jQuery.ajax(_.extend({
                    contentType: 'application/json',
                    dataType: 'json',
                    error: options.error,
                    headers: user.authorizationHeader('program'),
                    success: options.success
                }, ajaxOptions));
            },
            methods = {
                create: function () {
                    ajax({
                        data: JSON.stringify(model.toJSON()),
                        method: 'POST',
                        url: url
                    });
                },
                delete: function () {
                    ajax({
                        method: 'DELETE',
                        url: url + model.id
                    });
                },
                read: function () {
                    // console.log('program.sync.read');
                    ajax({
                        method: 'GET',
                        url: url + id
                    });
                },
                update: function () {
                    ajax({
                        data: JSON.stringify(model.changed),
                        method: 'PUT',
                        url: url + model.id
                    });
                }
            };
        if (methods[method]) {
            methods[method](options);
        } else {
            Backbone.sync.apply(this, arguments);
        }
        this.channels.program.trigger(method, {id: id});
    },
    update: function (serializedForm, callback) {
        const processedForm = formProcessor(serializedForm);
        this.set(processedForm);
        if (!_.isEmpty(this.changed)) {
            // eslint-disable-next-line no-undefined
            this.save(undefined, {
                success: function () {
                    if (callback) {
                        callback(null);
                    }
                },
                error: function (model, xhr/*, options*/) {
                    if (callback) {
                        callback('Unable to update program' + (xhr.responseJSON ? '\n(' + xhr.responseJSON.message + ')' : ''));
                    }
                }
            });
        } else {
            if (callback) {
                callback(null);
            }
        }
    },
    walkscore: function (/*callback*/) {
        const parse = function (results) {
                const o = {
                    ws_link: results.ws_link,  // jshint ignore:line
                    walk: {
                        score: results.walkscore == +results.walkscore ? results.walkscore : '?', // jshint ignore:line
                        description: results.description || '?'
                    }
                };
                if (results.bike) {
                    o.bicycle = {
                        score: results.bike.score == +results.bike.score ? results.bike.score : '?', // jshint ignore:line
                        // eslint-disable-next-line no-undefined
                        description: results.bike.description === undefined ? '?' : results.bike.description
                    };
                }
                if (results.transit) {
                    o.transit =  {
                        score: results.transit.score == +results.transit.score ? results.transit.score : '?', // jshint ignore:line
                        // eslint-disable-next-line no-undefined
                        description: results.transit.description === undefined ? '?' : results.transit.description
                    };
                }
                return o;
            },
            mockdata = {
                'status': 1,
                'walkscore': 63,
                'description': 'Somewhat Walkable',
                'updated': '2019-06-01 06:44:24.930024',
                'logo_url': 'https://cdn.walk.sc/images/api-logo.png',
                'more_info_icon': 'https://cdn.walk.sc/images/api-more-info.gif',
                'more_info_link': 'https://www.redfin.com/how-walk-score-works',
                'ws_link': 'https://www.walkscore.com/score/500-East-5th-Street-Dayton-OH-45402/lat=39.75936000/lng=-84.20909400/?&utm_medium=ws_api&utm_campaign=ws_api',
                'help_link': 'https://www.redfin.com/how-walk-score-works',
                'snapped_lat': 39.759,
                'snapped_lon': -84.2085,
                'bike': {
                    'score': 78,
                    'description': 'Very Bikeable'
                }
            },
            latitude = this.get('latitudeCache'),
            longitude = this.get('longitudeCache');
        let url;
        if (!configuration.mockdata.walkscore) {
            if (latitude && longitude) {
                url = configuration.apiUrlBase + 'score?latitude=' + latitude + '&longitude=' + longitude;
                jQuery.getJSON(url, _.bind(function (results) {
                    this.trigger('walkscore:scores', parse(results));
                }, this));
            }
        } else {
            // callback(null, parse(mockdata));
            this.trigger('walkscore:scores', parse(mockdata));
        }
    }
});
